/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import {observer, inject} from 'mobx-react';
import {StoreProps} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
interface HotkeyProps extends StoreProps {
    keyCombo: string;
    callback: (k?: ExtendedKeyboardEvent) => any;
    description?: string;
    children?:
        | React.ReactNode
        | ((removeHotkey: EventHandler, pauseHotkey?: EventHandler) => React.ReactNode);
}

/********************************************* EXPORT *********************************************/
/**
 * Globally register a hotkey
 *
 * @param {keyCombo} string Combination of keys that trigger the given callback
 * @param {Function} callback Function run when key combo is pressed
 * @param {ReactNode} children {optional}
 *                    If not provided render null
 *                    If React Node, pass it thru
 *                    If function w 1 arg given, run it w hotkey disposer function as arg
 *                    If function w 2 args given, pass hotkey pauser as 2nd arg
 */
@inject('appState')
@observer
export class Hotkey extends React.Component<HotkeyProps> {
    /**
     * Build a global hotkey
     */
    render() {
        this.props.appState.uiStore.hotkeyStore.addHotkey({
            keyCombo: this.props.keyCombo,
            description: this.props.description,
            callback: this.props.callback,
        });

        if (!this.props.children) {
            return null;
        }

        const disposer = this.props.appState.uiStore.hotkeyStore.removeHotkey(this.props.keyCombo);

        // TODO add hotkey list to store (for disposal)
        return typeof this.props.children === `function` ? (
            this.props.children(disposer)
        ) : (
            <>{this.props.children}</>
        );
    }
}
